// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View1_wrapper__2eLzA","topicTitle":"View1_topicTitle__1qwth"};